import { Form, Loading } from 'antd-mobile'
import dayjs from 'dayjs'
import { toJS } from 'mobx'
import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect, useState, useRef } from 'react'

import NewEditForm from '@/components/NewEditForm'
import { StatusCode } from '@/components/NewEditForm/enum'
import useNoAuthForm from '@/components/NewEditForm/hooks/useNoAuthForm'
import { certificateFromData } from '@/components/NewEditForm/UILibrary/HYBElement/BlockLevel/BlockLevelForm/utils'
import { DATEPICKER_MIN_DEFAULT_TIMESTAMP } from '@/constants'
import useVariable from '@/hooks/useVariable'
import jobStore from '@/store/components/entryJob'

import HPopup from '../../HYBVant/HPopup'

import './index.less'

const Education: React.FC<any> = ({ visible, onCancel, qrcodeId, modalData }) => {
  const [formIt] = Form.useForm()
  const currentFiledsRef: any = useRef(null)
  const [formInfo, setFormInfo] = useState([])

  const {
    changeEducation,
    education,
    employeeIds,
    educationStatus,
    changeAllEducation,
    cacheEducationJson,
    changeCacheEducationJson
  } = useLocalObservable(() => jobStore)
  const injectVariable = useVariable({
    vars: {
      minDate: DATEPICKER_MIN_DEFAULT_TIMESTAMP
    }
  })
  const { option, optionStatus } = useNoAuthForm('educational_experience_from', qrcodeId)

  const onFinish = async (fieldValues: any) => {
    const attachments = certificateFromData(fieldValues?.attachments || [])
    const start_date_old = fieldValues?.education_date?.[0] || fieldValues?.start_date
    const start_date = start_date_old ? dayjs(start_date_old).format('YYYY-MM-DD') : ''
    const end_date_old = fieldValues?.education_date?.[1] || fieldValues?.end_date
    const end_date = end_date_old ? dayjs(end_date_old).format('YYYY-MM-DD') : ''
    const field = {
      ...(currentFiledsRef.current || {}),
      ...fieldValues,
      attachments,
      employee_id: employeeIds?.[0],
      start_date,
      end_date
      // education_name: store.getOptions('HRM_EDUCATION_LEVEL')?.find(x => x.value === fieldValues?.education_level)?.name
    }

    // 快速入职
    educationStatus === 'Add' && changeEducation(field)
    educationStatus === 'Edit' &&
      changeAllEducation(
        education.map((x) => {
          if (x.active) return field
          return x
        })
      )
    onCancel()
  }
  const deleteInfo = async () => {
    educationStatus === 'Edit' && changeAllEducation(education.filter((x) => !x.active))
    onCancel()
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }

  useEffect(() => {
    const setFieldValues = () => {
      const fields = education.find((x) => x.active)
      const attachment = fields?.attachment?.map((x: any) => x?.oss_key || x) || []
      const start_date_old = fields?.education_date?.[0] || fields?.start_date
      const end_date_old = fields?.education_date?.[1] || fields?.end_date
      fields.education_date = start_date_old && end_date_old ? [start_date_old, end_date_old] : []
      currentFiledsRef.current = fields
      formIt.setFieldsValue({
        ...fields,
        attachment
      })
    }
    educationStatus === 'Edit' && formInfo?.length && setFieldValues()
  }, [educationStatus, formInfo])

  useEffect(() => {
    if (optionStatus === StatusCode.done) {
      const _formInfo: any = injectVariable(option.formInfo)
      setFormInfo(_formInfo)
      console.log(_formInfo, '_formInfo')
      changeCacheEducationJson(_formInfo)
    }
  }, [option, optionStatus])

  console.log('formInfo111', qrcodeId, toJS(education), toJS(cacheEducationJson), educationStatus)

  return (
    <HPopup title='教育经历' hasOk={false} className='lg' visible={visible} onCancel={onCancel}>
      {Array.isArray(cacheEducationJson) || optionStatus === StatusCode.done ? (
        <NewEditForm
          formInst={formIt}
          formInfo={cacheEducationJson ?? formInfo ?? []}
          onFinish={onFinish}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      ) : (
        <Loading className='init-loading lg' />
      )}
    </HPopup>
  )
}

export default observer(Education)
